export default __webpack_public_path__ + "static/media/slider_horizontal_theme2.06ce59ac.svg";